import CoverageBadge from '../../../createAndEdit/components/CoverageBadge';
import { IBudgetItem } from '../../../createAndEdit/types';
import { parseDiscountPercent, parseQuantityToNumber } from '../../../createAndEdit/utils/budgetCalculations';

interface IDetailServiceItemsTableMobileProps {
  items: IBudgetItem[];
  serviceSubtotal?: number;
}

const DetailServiceItemsTableMobile = (props: IDetailServiceItemsTableMobileProps) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const parseQty = (qty: string | number | undefined): number => {
    if (qty === undefined || qty === null) return 0;
    return parseQuantityToNumber(String(qty));
  };

  const visibleItems = (props.items || []).filter((item) => {
    if (item.removed === true) return false;
    const quantity = parseQty(item.quantity);
    return quantity > 0;
  });

  const calculatedSubtotal = () => {
    return visibleItems.reduce((sum, item) => {
      if (item.isCovered === true) return sum;
      return sum + (parseQty(item.quantity) * item.value * (1 - parseDiscountPercent(item.discount) / 100));
    }, 0);
  };

  return (
    <div className="mb-3 w-full">
      <div className="flex flex-col gap-3">
        {visibleItems.map((item, index) => {
          const isRemoved = item.removed === true;
          const isCovered = item.isCovered === true;
          const notCoveredReason = item.notCoveredReason;
          const subtotal = isCovered ? 0 : parseQty(item.quantity) * item.value * (1 - parseDiscountPercent(item.discount) / 100);
          
          return (
            <div
              key={`item-${item.ref}-${index}`}
              className={`border border-gray-200 rounded-md p-3 ${isRemoved ? 'bg-red-50' : 'bg-white'}`}
            >
              <div className="flex flex-col gap-2">
                <div className="flex flex-row justify-between items-start">
                  <div className="flex-1">
                    <div className="text-size-12 text-gray-600">Ref.</div>
                    <div className="text-size-14 font-semibold">{item.ref}</div>
                  </div>
                  <div className="flex-1">
                    <div className="text-size-12 text-gray-600">Item</div>
                    <div className="text-size-14 font-semibold">{item.item}</div>
                  </div>
                </div>
                <div>
                  <div className="text-size-12 text-gray-600">Descrição</div>
                  <div className="text-size-14">{item.description}</div>
                </div>
                <div className="mb-2">
                  <div className="text-size-12 text-gray-600">Cobertura</div>
                  <CoverageBadge isCovered={isCovered} notCoveredReason={notCoveredReason} />
                </div>
                <div className="flex flex-row gap-4">
                  <div className="flex-1">
                    <div className="text-size-12 text-gray-600">Quantidade</div>
                    <div className="text-size-14 text-right">{item.quantity}</div>
                  </div>
                  <div className="flex-1">
                    <div className="text-size-12 text-gray-600">Valor (R$)</div>
                    <div className="text-size-14 text-right">{formatCurrency(item.value)}</div>
                  </div>
                  <div className={`flex-1 ${isCovered ? 'opacity-60' : ''}`}>
                    <div className="text-size-12 text-gray-600">% Desconto</div>
                    <div className={`text-size-14 text-right ${isCovered ? 'bg-gray-100 rounded px-1' : ''}`}>{item.discount}</div>
                  </div>
                  <div className={`flex-1 ${isCovered ? 'opacity-60' : ''}`}>
                    <div className="text-size-12 text-gray-600">Subtotal (R$)</div>
                    <div className={`text-size-14 font-bold text-right ${isCovered ? 'bg-gray-100 rounded px-1' : ''}`}>{formatCurrency(subtotal)}</div>
                  </div>
                </div>
                {isRemoved && (
                  <div className="text-red-400 text-size-12 font-bold mt-2">
                    Removido pelo Volks|total
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {typeof props.serviceSubtotal === 'number' && (
        <div className="mt-4 text-right pr-2">
          <span className="text-gray-600 mr-2 text-size-14">Subtotal do serviço:</span>
          <span className="font-bold text-size-16">{formatCurrency(calculatedSubtotal())}</span>
        </div>
      )}
    </div>
  );
};

export default DetailServiceItemsTableMobile;
